import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { navigate } from '@reach/router';
import { Drawer, Tooltip, Dropdown, Menu, Space } from 'antd';
import * as Icon from '@ant-design/icons';
import { Location } from '@reach/router';
import { connect } from 'react-redux';
import { usePostHog } from 'posthog-js/react'

import Wrapper from './wrapper';
import vietnamFlag from '../images/VN.png';
import englishFlag from '../images/GB.png';
import { media } from '../utils/media';
import { logout, changeLocale } from '../actions';
import Link from '../components/link';

const profileMenu = (handleLogout, isAdmin) => (
  <Menu>
    <Menu.Item key="0">
      <Icon.UserOutlined />{' '}
      <span role='button' onClick={() => navigate('/user/dashboard')}>Tài khoản</span>
    </Menu.Item>
    {isAdmin && <Menu.Item key="1">
      <Icon.SettingOutlined />{' '}
      <span role='button' onClick={() => navigate('/admin')}>Trang quản trị</span>
    </Menu.Item>}
    <Menu.Divider />
    <Menu.Item key="2">
      <Icon.LogoutOutlined />{' '}
      <span role='button' onClick={handleLogout}>Đăng xuất</span>
    </Menu.Item>
  </Menu>
);

const Container = styled.div`
  background: #3980F6;
  overflow: hidden;
`;

const Item = styled.div`
  display: block;
  padding: ${props => (props.right ? '10px 3px' : '12px 6px')};
  min-width: ${props => (props.right ? '0px' : '64px')};
  text-transform: uppercase;
  cursor: pointer;
  font-size: 14px;
  color: white;
  float: ${props => (props.right ? 'right' : 'left')};
  text-align: ${props => (props.right ? 'right' : 'left')};
  ${media.phablet`
    font-size: 13px;
  `};
  a {
    color: white;
    ::after {
      background-color: white;
      bottom: -4px;
    }
  }
`;

const DrawerItem = styled.div`
  cursor: pointer;
  text-transform: uppercase;
  /* color: white; */
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0px;
  ${media.phablet`
    font-size: 13px;
  `};
  a {
    color: #3980F6;
    ::after {
      background-color: white;
      bottom: -4px;
    }
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
  font-size: 20px;
  padding: 8px 0px;
  color: white;
  ${media.tablet`
    display: inline-block;
  `};
`;

const Flag = styled.div`
  background-image: url(${props => props.src});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  border: ${props => (props.selected ? '2px solid white' : 'none')};
  width: 30px;
`;

const NavItems = styled.div`
  display: block;
  ${media.tablet`
    display: none;
  `};
`;

const Navigation = ({
  changeLocale,
  logout,
  menu,
  locale,
  isLogged,
  userInfo,
  srItems,
}) => {
  const [state, setState] = useState({showDrawer: false})
  const posthog = usePostHog()

  useEffect(() => {
    if (userInfo) {
        // Identify sends an event, so you want may want to limit how often you call it
        posthog?.identify(userInfo._id, {
            email: userInfo.email,
        })
    }
}, [posthog, userInfo])

  const changeLanguage = (locale) => {
    changeLocale(locale);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  }

  return (
    <Fragment>
      <Container>
        <Wrapper wrapperStyle={{ backgroundColor: 'transparent' }}>
          <Hamburger onClick={() => setState({ showDrawer: true })}>
            <Icon.MenuUnfoldOutlined />
          </Hamburger>
          <NavItems>
            {menu && menu.length > 0 && menu.map(item => {
              if (item.url === '/shareholder') {
                return (
                  <Dropdown key={item._id} trigger={['hover']} menu={{
                    items: srItems?.map(item => ({
                      key: item._id,
                      label: <Space>◈<span>{item.name}</span></Space>,
                      onClick: () => navigate(item._id !== '63bb940f81cac63b2547ffaa' ? `/blog/${item._id}` : '/shareholder-meeting'),
                      style: {padding: '12px 8px', color: '#3980F6'}
                    })) || []
                  }}>
                    <Item>
                      <Link to={item.url} activeclassname='active'>{locale === 'en' && item.engTitle ? item.engTitle : item.title}</Link>
                    </Item>
                  </Dropdown>
                )
              }
              return (
                <Item key={item._id}>
                  <Link to={item.url} activeclassname='active'>{locale === 'en' && item.engTitle ? item.engTitle : item.title}</Link>
                </Item>
              )
            })}
          </NavItems>
          <Location>
            {({ location }) => (
              <Fragment>
                <Item right onClick={() => changeLanguage('en')}>
                  <Tooltip title='English'>
                    <Flag selected={locale === 'en'} src={englishFlag} />
                  </Tooltip>
                </Item>
                <Item right onClick={() => changeLanguage('vi')}>
                  <Tooltip title='Tiếng Việt'>
                    <Flag selected={locale === 'vi'} src={vietnamFlag} />
                  </Tooltip>
                </Item>
              </Fragment>
            )}
          </Location>
          {isLogged
            ? (
              <Item right style={{ marginRight: 10, padding: '12px 3px' }}>
                <Dropdown overlay={profileMenu(handleLogout, userInfo.role === 2)} trigger={['click']}>
                  <a href='#'>{userInfo.fullname}</a>
                </Dropdown>
              </Item>
            )
            : (
              <Item right style={{ marginRight: 10, padding: '12px 3px' }}>
                <Link to='/user'>Đăng nhập</Link>
              </Item>
            )}
        </Wrapper>
      </Container>
      <Drawer
        title="May Thắng Lợi"
        placement='left'
        closable
        onClose={() => setState({ showDrawer: false })}
        open={state.showDrawer}
      >
        {/* {menu && menu.length > 0 && menu.map(item => (
          <DrawerItem key={item._id}>
            <Link to={item.url} activeclassname='active'>{locale === 'en' && item.engTitle ? item.engTitle : item.title}</Link>
          </DrawerItem>
        ))} */}
        {menu && menu.length > 0 && menu.map(item => {
          if (item.url === '/shareholder') {
            return (
              <>
                <DrawerItem key={item._id}>
                  <Link to={item.url} activeclassname='active'>{locale === 'en' && item.engTitle ? item.engTitle : item.title}</Link>
                </DrawerItem>
                {srItems.map(item => (
                  <DrawerItem key={item._id} style={{padding: '12px 8px', color: '#3980F6'}} onClick={() => setState({ showDrawer: false })}>
                    <Link to={item._id !== '63bb940f81cac63b2547ffaa' ? `/blog/${item._id}` : '/shareholder-meeting'} activeclassname='active'>
                      <Space>◈<span>{item.name}</span></Space>  
                    </Link>
                  </DrawerItem>
                ))}
              </>
            )
          }
          return (
            <DrawerItem key={item._id}>
              <Link to={item.url} activeclassname='active'>{locale === 'en' && item.engTitle ? item.engTitle : item.title}</Link>
            </DrawerItem>
          )
        })}
      </Drawer>
    </Fragment>
  );
}

export default connect(state => ({
  isLogged: state.user.isLogged,
  userInfo: state.user.userInfo,
  locale: state.setting.locale,
  srItems: state.layout.srItems,
}), {
  logout,
  changeLocale,
})(Navigation);
